import React, { useContext } from 'react'
import MainLayout from "../../components/layouts/mainLayout";
import { Col, Row, Icon } from 'antd';
import ReCAPTCHA from "react-google-recaptcha";
import Info from '../../components/common/info';
import FormLoading from '../../components/common/loaders/formLoading';
import { Link } from "react-router-dom";
import { useMutation } from '@apollo/client';
import { useState } from "react";
import { useForm } from "react-hook-form";
import { LOGIN_MUTATION } from "../../utils/query";
import { VintageHeaderIcon } from
    "../../components/common/icons/vintageHeaderIcon";
import { AuthContext } from '../../context/auth';
import { Redirect } from 'react-router-dom';

export default function Login(props) {
    const context = useContext(AuthContext);

    const [GR_VALUE, SET_GR_VALUE] = useState('');
    const [GR_ERROR, SET_GR_ERROR] = useState('');

    const [login, { loading, error }] = useMutation(LOGIN_MUTATION, {
        onCompleted(userData) {
            console.log('result data : ' + JSON.stringify(userData));
            context.login(userData.login);
            props.history.push('/dashboard')
        },
        onError() {

        }
    });
    const { register, formState: { errors }, handleSubmit } = useForm();

    const onGRChange = (value) => {
        SET_GR_VALUE(value);
    }

    const onGRExpired = () => {
        SET_GR_VALUE('');
    }

    const onSubmit = formData => {

        console.log('GR_VALUE' + GR_VALUE);

        if (GR_VALUE === '') {
            SET_GR_ERROR('لطفا کد امنیتی را وارد کنید');
            return;
        }
        else {
            login({ variables: { identifier: formData.identifier, password: formData.password } });
        }
    }

    if (context.user === null) {
        return (
            <MainLayout>
                <div className={"indevelopmentWrapper"}>
                    <div className="container">
                        <div className="indevelopment">
                            <Row className={"indevelopmentRow"}>
                                <Col xs={24} sm={22} md={18} lg={12} xl={9}>

                                    <div className="InDevelopmentCard">
                                        {error ? (
                                            <p className={"inputFormRrrorText"} style={{ textAlign: 'center', marginBottom: 15 }}>
                                                {error.graphQLErrors.map(({ message }, i) => {
                                                    return <span key={i}>{message}</span>
                                                })}
                                            </p>
                                        ) : ''}
                                        {loading ? (
                                            <FormLoading />
                                        ) : (
                                            <div style={{ width: '100%' }}>
                                                <div className="pageTitle1Wrapper">
                                                    <div className="pageTitle1">
                                                        <div className="pageTitle1Icon" dangerouslySetInnerHTML={VintageHeaderIcon()}></div>
                                                        <h1 id={"certificates"}>ورود به حساب کاربری</h1>
                                                    </div>
                                                </div>
                                                <form onSubmit={handleSubmit(onSubmit)}>
                                                    <div className="quickOrderForm">
                                                        <Row className="quickOrderFormRow">

                                                            <Col span={24}>
                                                                <div className="formItem">
                                                                    <p className={"formItemHelp"}>نام کاربری یا ایمیل *</p>
                                                                    <input
                                                                        className={"ant-input ant-input-lg"}
                                                                        type="text"
                                                                        {...register("identifier", { required: true, maxLength: 30, minLength: 5 })}
                                                                        placeholder="نام کاربری یا ایمیل"
                                                                    />
                                                                    <p className={"inputFormRrrorText"}>
                                                                        {errors.identifier && errors.identifier.type === "required" && "این فیلد ضروری است"}
                                                                        {errors.identifier && errors.identifier.type === "minLength" && "حداقل ۵ کاراکتر لازم است"}
                                                                        {errors.identifier && errors.identifier.type === "maxLength" && "حداکثر ۳۰ کاراکتر مجاز است"}
                                                                        {errors.identifier && errors.identifier.type === "pattern" && "کاراکتر نا مناسب"}
                                                                    </p>
                                                                </div>
                                                            </Col>


                                                            <Col span={24}>
                                                                <div className="formItem">
                                                                    <p className={"formItemHelp"}>رمز عبور *</p>
                                                                    <input
                                                                        className={"ant-input ant-input-lg"}
                                                                        {...register("password", { required: true, minLength: 6, maxLength: 32 })}
                                                                        type="password"
                                                                        placeholder="رمز عبور خود را وارد کنید"

                                                                    />
                                                                    <p className={"inputFormRrrorText"}>
                                                                        {errors.password && errors.password.type === "required" && "این فیلد ضروری است"}
                                                                        {errors.password && errors.password.type === "minLength" && "حداقل ۶ کاراکتر لازم است"}
                                                                        {errors.password && errors.password.type === "maxLength" && "حداکثر ۳۲ کاراکتر مجاز است"}
                                                                        {errors.password && errors.password.type === "pattern" && "کاراکتر نا مناسب"}
                                                                    </p>
                                                                </div>
                                                            </Col>


                                                            <Col span={24}>
                                                                <div className="recaptchaWrapper">
                                                                    <ReCAPTCHA
                                                                        sitekey={Info.GR_KEY}
                                                                        onChange={onGRChange}
                                                                        onExpired={onGRExpired}
                                                                        hl={'fa'}
                                                                    />
                                                                </div>
                                                                {
                                                                    GR_ERROR === '' ? '' : (
                                                                        <p className={"inputFormRrrorText"}>
                                                                            این فیلد اجباری می‌باشد
                                                                        </p>
                                                                    )
                                                                }
                                                            </Col>

                                                            <Col span={24}>

                                                                <div className={"formSubmitButton"}>
                                                                    <div className={"normalButtonWrapper darkBtn"}>
                                                                        <button type="submit" className={"normalButton loginButton"}>
                                                                            <div className="normalButtonInner">
                                                                                <div>
                                                                                    <Icon type={'login'} />
                                                                                </div>
                                                                                <p>ورود به حساب کاربری</p>
                                                                            </div>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </Col>

                                                            <Col xs={24} md={12}>
                                                                <Link to={'/sign-up'}><div className={"link-text"}>ساخت حساب کاربری جدید</div></Link>
                                                            </Col>
                                                            <Col xs={24} md={12}>
                                                                <Link to={'/reset-passord'}>
                                                                    <div className={"link-text"}>رمز عبور خود را فراموش کردید ؟</div>
                                                                </Link>
                                                            </Col>


                                                        </Row>
                                                    </div>
                                                </form>
                                            </div>


                                        )}



                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </MainLayout>
        )
    }
    else {
        return (
            <Redirect to={"/dashboard"} />
        )
    }

}